<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<el-form ref="form" :model="form" label-width="60px" size="mini">
					<el-form-item label="商品ID">
						<el-input v-model="form.goodscode"></el-input>
					</el-form-item>
					<el-form-item label="目标">
						<el-input-number v-model="form.kpi"></el-input-number>
					</el-form-item>
					<el-form-item label="时间">
						<el-date-picker align="center" value-format="timestamp" v-model="form.date" type="month" placeholder="选择月">
						</el-date-picker>
					</el-form-item>
				</el-form>
			</template>
			<template #footer>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			nodeid: {
				default: () => {
					return 0
				}
			},
		},
		data() {
			return {
				parentdata: [],
				modal_title: '新增品类目标KPI',
				modal_width: 400,
				modal_height: 'auto',
				form: {
					goodscode:null,
					kpi: 0,
					date: this.$Moment().startOf('month').valueOf(),
				}
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_onshow() {
				this.form = {
					nodeid:this.nodeid,
					goodscode:null,
					kpi: 0,
					date: this.$Moment().startOf('month').valueOf(),
				}
			},
			submit() {
				let obj = JSON.parse(JSON.stringify(this.form))
				obj.date = obj.date/1000
				this.$api.BIshopgoods.addgroupkpi(obj).then(()=>{					
					this.modal_cancel()
				})
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>